import { getAllUserNameEmailMobileNo } from "../../Service/AllAccessControlAPI";
import swal from "sweetalert";

export const validateUserName = async (value) => {
  // setTimeout(async () => {
  let TextError;
  await getAllUserNameEmailMobileNo()
    .then((result) => {
      if (result?.data?.length !== 0) {
        console.log("All Users List", result);
        let temp = result.data.userName.filter((obj) => {
          return obj === value;
        });
        if (temp.length !== 0) {
          TextError = "This Username is already exist";
          // swal("Failed", `${TextError}`, "warning");
        }
      }
    })
    .catch((TextError) => {
      console.log("All Users List Error", TextError);
    });
  return TextError;
  // }, 200);
};

export const validateEmail = async (value) => {
  // setTimeout(async () => {
  let error;
  await getAllUserNameEmailMobileNo()
    .then((result) => {
      if (result?.data?.length !== 0) {
        console.log("All Users emailId List", result);
        let temp = result.data.emailId.filter((obj) => {
          return obj === value;
        });
        if (temp.length !== 0) {
          error = "This Email is already exist";
          // swal("Failed", `${error}`, "warning");
        }
      }
    })
    .catch((error) => {
      console.log("All Users List Error", error);
    });
  return error;
  // }, 200);
};

export const validateMobileNo = async (value) => {
  // setTimeout(async () => {
  let error;
  await getAllUserNameEmailMobileNo()
    .then((result) => {
      if (result?.data?.length !== 0) {
        console.log("All Users MobileNo List", result);
        let temp = result.data.mobileNo.filter((obj) => {
          return obj === value;
        });
        if (temp.length !== 0) {
          error = "This Mobile No. is already exist";
          // swal("Failed", `${error}`, "warning");
        }
      }
    })
    .catch((error) => {
      console.log("All Users List Error", error);
    });
  return error;
  // }, 200);
};
